module.exports = __webpack_public_path__ + "img/logo.9f52f0ea.png";